$(function() {
  var pagesSlider = $('[data-carousel="pages"]');

  if (pagesSlider.length > 0) {
    pagesSlider.slick({
      slidesToShow: 1,
      mobileFirst: true,
      dots: true,
      speed: 500,
      prevArrow: $("[data-control-prev]"),
      nextArrow: $("[data-control-next]")
    });
  }

  var mainPagesSlider = $('[data-carousel="main-pages"]');
  const mainPagesSliderConfig = {
    slidesToShow: 1,
    mobileFirst: true,
    speed: 500,
    prevArrow: $("[data-control-prev]"),
    nextArrow: $("[data-control-next]"),
    fade: true,
  };

  if (mainPagesSlider.length > 0) {
    mainPagesSlider.slick(mainPagesSliderConfig);
  }

  // Language Info

  $(".multiple").click(function(e) {
    e.preventDefault();
  });



  if ($('.js-product-theme-image').length > 0) {
    $('.js-product-theme-image').slick({
      slidesToShow: 1,
      mobileFirst: true,
      dots: false,
      speed: 500,
      loop: false,
      prevArrow: $(".btn-circle--left"),
      nextArrow: $(".btn-circle--right")
    });
  }

  // color variant selector
  $("[data-color-variant]").change(function() {
    let curColorVariant = $(this).data("color-variant");
    const $dataFeaturedImage = $("[data-featured-image]");
    $dataFeaturedImage.addClass("hidden");
    $dataFeaturedImage.parent('.screenshot').parent('main-page-images__item').addClass('hidden');
    $(`[data-featured-image="${curColorVariant}"]`).removeClass("hidden");
    $(`[data-featured-image="${curColorVariant}"]`).parent(".screenshot").parent(".main-page-images__item").addClass('hidden');

    $('[data-carousel="main-pages"]').slick('unslick').slick('reinit').slick(mainPagesSliderConfig);
  });

  if( $('.js-popup-internal-pages').length ) {

    $(".js-gallery-internal-pages").magnificPopup({
      delegate: ".js-popup-internal-pages",
      centerMode: true,
      type: "image",
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: "mfp-with-zoom mfp-img-mobile gallery-internal-pages",
      image: {
        verticalFit: true
      },
      gallery: {
        enabled: true
      }
    });
  }
});
